<template>
  <div v-if="slides.length">
    <full-page ref="fullpage" :options="this.setLicense" id="fullpage">
      <div v-for="slide in slides" :key="slide.index" class="section w-full">
        <PageSlideItem
          class="h-screen section w-full flex section relative bg-black"
          :headline="slide.headline"
          :intro="slide.intro"
          :src="slide.src"
          :decoration="slide.decoration"
          :btnText="slide.btnText"
          :btnTarget="slide.btnTarget"
        />
      </div>
    </full-page>
    <!-- <section v-for="slide in slides" :key="slide.index">
      <PageSlideItem
        class="h-screen section w-full flex section relative bg-black"
        :headline="slide.headline"
        :intro="slide.intro"
        :src="slide.src"
        :btnText="slide.btnText"
        :btnTarget="slide.btnTarget"
      />
    </section> -->
  </div>
</template>

<script>
import PageSlideItem from './PageSlideItem.vue'
import fullpageLicense from '../services/fullpageLicense'

export default {
  name: 'PageSlides',
  components: {
    PageSlideItem,
  },
  props: {
    slides: Array,
  },
  data() {
    return {
      inMove: false,
      activeSection: 0,
      offsets: [],
      touchStartY: 0,
      options: {
        licenseKey: '5683FC71-5BC24572-B0EE9B4C-D8CD6110',
      },
    }
  },
  computed: {
    setLicense() {
      const license = fullpageLicense()
      const obj = { licenseKey: license }
      return obj
    },
  },
  // methods: {
  //   calculateSectionOffsets() {
  //     const sections = document.getElementsByTagName('section')
  //     const { length } = sections

  //     for (let i = 0; i < length; i += 1) {
  //       const sectionOffset = sections[i].offsetTop
  //       this.offsets.push(sectionOffset)
  //     }
  //   },
  //   handleMouseWheel(e) {
  //     if (e.wheelDelta < 40 && !this.inMove) {
  //       this.moveUp()
  //     } else if (e.wheelDelta > 40 && !this.inMove) {
  //       this.moveDown()
  //     }

  //     e.preventDefault()
  //     return false
  //   },
  //   handleMouseWheelDOM(e) {
  //     if (e.detail > 0 && !this.inMove) {
  //       this.moveUp()
  //     } else if (e.detail < 0 && !this.inMove) {
  //       this.moveDown()
  //     }

  //     return false
  //   },
  //   moveDown() {
  //     this.inMove = true
  //     this.activeSection -= 1

  //     if (this.activeSection < 0) this.activeSection = this.offsets.length - 1

  //     this.scrollToSection(this.activeSection, true)
  //   },
  //   moveUp() {
  //     this.inMove = true
  //     this.activeSection += 1

  //     if (this.activeSection > this.offsets.length - 1) this.activeSection = 0

  //     this.scrollToSection(this.activeSection, true)
  //   },
  //   scrollToSection(id, force = false) {
  //     if (this.inMove && !force) return false

  //     this.activeSection = id
  //     this.inMove = true

  //     document
  //       .getElementsByTagName('section')
  //       [id].scrollIntoView({ behavior: 'smooth' })

  //     setTimeout(() => {
  //       this.inMove = false
  //     }, 500)
  //   },
  //   touchStart(e) {
  //     e.preventDefault()

  //     this.touchStartY = e.touches[0].clientY
  //   },
  //   touchMove(e) {
  //     if (this.inMove) return false
  //     e.preventDefault()

  //     const currentY = e.touches[0].clientY

  //     if (this.touchStartY < currentY) {
  //       this.moveDown()
  //     } else {
  //       this.moveUp()
  //     }

  //     this.touchStartY = 0
  //     return false
  //   },
  // },
  // mounted() {
  //   this.calculateSectionOffsets()

  //   window.addEventListener('DOMMouseScroll', this.handleMouseWheelDOM) // Mozilla Firefox
  //   window.addEventListener('mousewheel', this.handleMouseWheel, {
  //     passive: false,
  //   })

  //   window.addEventListener('touchstart', this.touchStart, { passive: false }) // mobile devices
  //   window.addEventListener('touchmove', this.touchMove, { passive: false }) // mobile devices
  // },
  // destroyed() {
  //   window.removeEventListener('mousewheel', this.handleMouseWheel, {
  //     passive: false,
  //   })
  //   window.removeEventListener('DOMMouseScroll', this.handleMouseWheelDOM) // Mozilla Firefox

  //   window.removeEventListener('touchstart', this.touchStart) // mobile devices
  //   window.removeEventListener('touchmove', this.touchMove) // mobile devices
  // },
}
</script>
<style scoped>
.fullpage {
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.sections-menu {
  position: fixed;
  z-index: 100;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
}

.sections-menu .menu-point {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background-color: #fff;
  display: block;
  margin: 1rem 0;
  opacity: 0.6;
  transition: 0.4s ease all;
  cursor: pointer;
}

.sections-menu .menu-point.active {
  opacity: 1;
  transform: scale(1.5);
}
</style>
